import { PasswordResetRequestForm } from '@/pages/PasswordResets/RequestForm'

export default function SchoolPasswordResetNew() {
  return (
    <PasswordResetRequestForm
      title="高校コーチ パスワード再設定"
      description="登録済みのメールアドレスに再設定リンクを送信します。"
      postPath="/school/password_resets"
      loginPath="/school/login"
    />
  )
}
